import { render, staticRenderFns } from "./table-container.vue?vue&type=template&id=a4c40236&"
import script from "./table-container.vue?vue&type=script&lang=js&"
export * from "./table-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports